export default __webpack_public_path__ + "static/rad-dad-logo-fa08d294df76af6c39f5d7962ca41c0e.png";